import { useState, useEffect } from "react";
import TriggerModal from "./TriggerModal";
import { MdAdd } from "react-icons/md";
import { IoMdClose } from "react-icons/io";
import QuestionForm from "./QuestionForm";
import TestTrigger from "./TestTrigger";
import AutoResizableTextarea from "../AutoResizableTextarea";
import ChatList from "../ChatList";
import SelectDataSourceModal from "../SelectDataSourceModal";
import { DataState } from "../../context/DataProvider";
import { FaFile } from "react-icons/fa6";
import { createTempBot } from "./../../services/api";
import { WORKFLOW_API_URL } from "./../../services/workflowApi";
import { v4 as uuidv4 } from "uuid"; // For unique IDs
import { FiEdit, FiTrash2 } from "react-icons/fi"; // Icons for buttons

import {
  appImages,
  dataSources,
  integrationData,
  triggerOptions,
} from "../../utils/constants";
import Button from "../custom/Button";
import { FaArrowLeftLong } from "react-icons/fa6";
import SelectedTriggerItem from "./SelectedTriggerItem";
import DataSourceModal from "../DataSourceModal";
import { getFileIcon } from "../chat/AttachmentIcon";
import TriggerNodeModal from "../workflow3/TriggerNodeModal";

const TriggerForm = ({ isModalOpen, closeModal, copyWorkflow = false, copyWorkflowData, isDialog = false }) => {
  const [isTriggerModalOpen, setIsTriggerModalOpen] = useState(false);
  const [isIntegrationModalOpen, setIsIntegrationModalOpen] = useState(false);
  const [isDataSourceModalOpen, setIsDataSourceModalOpen] = useState(false);

  const [selectTrigerOptions, setSelectTrigerOptions] = useState([]);
  const [selectIntegrationOptions, setSelectIntegrationOptions] = useState([]);
  const [selectDataSourceOptions, setSelectDataSourceOptions] = useState([]);
  const [isDataSourceSelectionModalOpen, setIsDataSourceSelectionModalOpen] =
    useState(false);

  // State for the NEW TriggerNodeModal
  const [isTriggerNodeModalOpen, setIsTriggerNodeModalOpen] = useState(false);
  const [currentTriggerNodeData, setCurrentTriggerNodeData] = useState(null);
  const [modalMode, setModalMode] = useState("add"); // 'add' or 'edit'
  

  const [appEventsData, setAppEventsData] = useState([]);
  const {
    createAndHandleClarificationQuestions,
    setError,
    botCreationId,
    setBotCreationId,
    userGoogleId,
    currentTaskDataSourceFiles,
  } = DataState();
  const [editOption, setEditOption] = useState(null);
  const [triggerName, setTriggerName] = useState(""); // State for storing the trigger name
  const [instruction, setInstruction] = useState(""); // State for storing the instruction

  const handleDataSourceModalClose = () => {
    setIsDataSourceSelectionModalOpen(false);
  };

  const fetchAppsandEventsData = async () => {
      try {
        const response = await fetch(
          `${WORKFLOW_API_URL}/canvas/appsAndTriggers`,
          {
            method: "POST", // Use the appropriate HTTP method (POST, PUT, etc.)
            headers: {
              "Content-Type": "application/json", // Specify that you're sending JSON
              Authorization: `Bearer ${userGoogleId}`,
            },
            credentials: "include",
            body: JSON.stringify({ apps: selectIntegrationOptions }), // Convert the payload to a JSON string
          }
        );
  
        if (!response.ok) {
          throw new Error(`Failed to fetch data: ${response.status}`);
        }
  
        const data = await response.json();
        // setAppData(data.appsData || []); // Update appData with the fetched data
        setAppEventsData(data.appsEventsData || []);
        // setAgentsData(data.agents || []); // <<< Store agents data
        console.log("Fteched apps event data:", data.appsEventsData);
        // fetchJiraProjects(data.appsEventsData || []);
      } catch (error) {
        console.error("Error fetching apps data:", error);
      }
    };
    useEffect(() => {
      console.log("App Integration Options in Normal Workflow:", selectIntegrationOptions)
      fetchAppsandEventsData();
      console.log(
        "App Integration Options changed",
        selectIntegrationOptions
      );
    }, [selectIntegrationOptions]);

  useEffect(() => {
    if (isModalOpen) {
      const createBot = async () => {
        try {
          const response = await createTempBot({
          }, userGoogleId);
          if (response.error) {
            setError(JSON.stringify(response.error));
            console.log("Temp bot creation error:", response.error);
            return;
          }
          if (response.bot_id) {
            console.log("Created temp bot:", response.bot_id);
            setBotCreationId(response.bot_id);
          }
        } catch (err) {
          setError(JSON.stringify(err));
          console.log("Temp bot creation error:", err);
        }
      };
      createBot();
    }
  }, [isModalOpen]);


  // --- Handlers for the new TriggerNodeModal ---

  const handleOpenTriggerModal = (mode, triggerNode = null) => {
    setModalMode(mode);
    if (mode === "add") {
      // Create a default structure for a new trigger node
      setCurrentTriggerNodeData({
        id: uuidv4().replace(/-/g, ""), // UUID v4 without hyphens, // Assign a temporary unique ID
        type: "trigger",
        data: {}, // Start with empty data
      });
    } else {
      // Use the existing trigger node data for editing
      setCurrentTriggerNodeData(triggerNode);
    }
    setIsTriggerNodeModalOpen(true);
  };

  const handleSaveTrigger = (savedNode) => {
    // Check if the node already exists
    const existingIndex = selectTrigerOptions.findIndex(
      (node) => node.id === savedNode.id
    );

    if (existingIndex > -1) {
      // Update existing node
      const updatedOptions = [...selectTrigerOptions];
      updatedOptions[existingIndex] = savedNode;
      setSelectTrigerOptions(updatedOptions);
    } else {
      // Add new node
      setSelectTrigerOptions((prev) => [...prev, savedNode]);
    }
    setIsTriggerNodeModalOpen(false); // Close modal on save
    setCurrentTriggerNodeData(null); // Clear current data
  };

  const handleDeleteTrigger = (nodeId) => {
    setSelectTrigerOptions((prev) => prev.filter((node) => node.id !== nodeId));
    setIsTriggerNodeModalOpen(false); // Close modal on delete
    setCurrentTriggerNodeData(null); // Clear current data
  };

  // --- End of new handlers ---

  const handleDeleteIntegrationOption = (optionId) => {
    setSelectIntegrationOptions((prev) =>
      prev.filter((item) => item.id !== optionId)
    );
  };
  const handleDeleteDataSourceOption = (optionId) => {
    setSelectDataSourceOptions((prev) =>
      prev.filter((item) => item.id !== optionId)
    );
  };

  const handleIntergrationEditOption = (option) => {
    setEditOption(option);
    setIsIntegrationModalOpen(true);
  };
  const handleDataSourceEditOption = (option) => {
    setEditOption(option);
    setIsDataSourceModalOpen(true);
  };

  const [showQuestionForm, setShowQuestionForm] = useState();
  const [showTestScreen, setShowTestScreen] = useState();
  const [isFormLoading, setIsFormLoading] = useState(false);
  const clearStates = () => {
    setSelectTrigerOptions([]);
    setSelectIntegrationOptions([]);
    setSelectDataSourceOptions([]);
    setTriggerName("");
    setInstruction("");
  };
  const handleNewInstructionSubmission = async () => {
    setIsFormLoading(true);
    try {
      const final_response = await createAndHandleClarificationQuestions(
        instruction,
        triggerName,
        selectTrigerOptions,
        selectIntegrationOptions,
        selectDataSourceOptions
      );
      if (final_response && final_response.questions) {
        setShowQuestionForm(true);
      } else {
        console.log("No Questions Returned");
      }
    } catch (error) {
    } finally {
      setIsFormLoading(false);
    }
  };
  const handleShowTestScreen = () => {
    setShowTestScreen(true);
  };

  useEffect(() => {
    if (copyWorkflow) {
      setInstruction(copyWorkflowData.task_description)
      // setSelectTrigerOptions(copyWorkflowData.trigger)
      
      // Assuming copyWorkflowData.trigger is an array of node-like objects
      setSelectTrigerOptions(copyWorkflowData.trigger || []); 
      setSelectIntegrationOptions(copyWorkflowData.apps_expanded)
      setSelectDataSourceOptions(copyWorkflowData.dataSources)
    }
  }, [copyWorkflow]);

  console.log("selectIntegrationOptions", selectIntegrationOptions);
  return (
    <div
      className={`fixed top-0 left-0 bg-black bg-opacity-20 backdrop-blur-sm w-screen h-screen items-center justify-center z-[100] transition-all ease-in-out duration-200 ${isModalOpen ? "flex" : "hidden"
        }`}
    >
      {copyWorkflowData?.name}
      {!showTestScreen && !showQuestionForm && (
        <div className="bg-1 h-[90%] max-w-3xl w-[90%] rounded-lg overflow-auto">
          <div className="flex justify-between gap-3 border-b br-1 px-3 py-5 text-p-text">
            <div>
              {!isDialog &&
                <input
                  className="px-3 py-1.5 text-p-text rounded-lg outline-none resize-none text-xl font-bold bg-2 w-fit text-center"
                  value={triggerName}
                  onChange={(e) => setTriggerName(e.target.value)}
                  placeholder="Untitled Workflow"
                />
              }
            </div>
            <div>
              <button
                onClick={closeModal}
                className="bg-1 transition-all duration-200 rounded-lg p-1.5"
              >
                <IoMdClose />
              </button>
            </div>
          </div>
          <div className="flex flex-col gap-8 p-6">
            <div className="flex flex-col gap-2">
              <div className="flex items-center justify-between gap-3 bg-zinc-950 px-3 py-2 rounded-lg">
                <div className="flex flex-col gap-1 ">
                  <h1 className="text-base font-semibold">App integrations</h1>
                  <p className="text-sm">
                    Add applications included in the workflow
                  </p>
                </div>
                <button
                  onClick={() => setIsIntegrationModalOpen(true)}
                  className="px-2 py-1 border border-zinc-200 duration-200 transition-all text-sm rounded-lg"
                >
                  ADD
                </button>
              </div>
              {selectIntegrationOptions.map((item) => (
                <SelectedTriggerItem
                  item={item}
                  handleEditOption={() => handleIntergrationEditOption(item)}
                  handleDeleteOption={handleDeleteIntegrationOption}
                />
              ))}
            </div>

            
            {/* --- NEW TRIGGER SECTION --- */}
            <div className="flex flex-col gap-2">
              <div className="flex items-center justify-between gap-3 bg-zinc-950 px-3 py-2 rounded-lg">
                <div className="flex flex-col gap-1 ">
                  <h1 className="text-base font-semibold">Triggers</h1>
                  <p className="text-sm text-p-text">
                    Events that automatically initiate the workflow.
                  </p>
                </div>
                <button
                  onClick={() => handleOpenTriggerModal("add")}
                  className="px-2 py-1 border border-zinc-200 duration-200 transition-all text-sm rounded-lg"
                >
                  ADD
                </button>
              </div>
              <div className="flex flex-col gap-2">
                {selectTrigerOptions.map((node) => {
                  const triggerKey = node.data?.triggerOption;
                  const imageUrl = appImages[triggerKey] || "/assets/logo.png";
                  return (
                  
                  <div
                    key={node.id}
                    className="flex items-center justify-between bg-zinc-800 p-2 rounded-md"
                  >
                    <div className="flex-shrink-0 rounded p-1">
                          <img
                            src={imageUrl}
                            alt={triggerKey}
                            className="w-5 h-5"
                          />
                        </div>
                    <span className="text-zinc-100 text-sm">
                      {node.data?.label || "Untitled Trigger"}
                    </span>
                    <div className="flex items-center gap-2">
                      <button
                        onClick={() => handleOpenTriggerModal("edit", node)}
                        className="p-1.5 hover:bg-zinc-700 rounded-md"
                        title="Edit"
                      >
                        <FiEdit className="w-4 h-4 text-zinc-300" />
                      </button>
                      <button
                        onClick={() => handleDeleteTrigger(node.id)}
                        className="p-1.5 hover:bg-zinc-700 rounded-md"
                        title="Delete"
                      >
                        <FiTrash2 className="w-4 h-4 text-red-500" />
                      </button>
                    </div>
                  </div>
                )}
                )}
              </div>
            </div>
            <div className="flex flex-col gap-1">
              <div className="flex flex-col gap-1">
                <h1 className="text-base font-semibold">
                  Workflow Instructions
                </h1>
              </div>
              <textarea
                value={instruction}
                onChange={(e) => setInstruction(e.target.value)} // Update instruction state
                className="bg-transparent resize-none h-52 border-zinc-500 r border rounded-lg px-4 py-2 text-base outline-none"
                placeholder="Instructions describe your workflow requirements in detail. Include all necessary steps, data processing instructions, and desired outcomes across integrated applications (e.g. Jira, Email, Sheets, Docs). Example: 'For every email received in the inbox, send an automated apology response explaining a 34 hour delay in support. Then, create a Jira task under the 'Support' Project, including the email content and tagging it as 'High Priority'. Notify the team lead in Slack once task is created."
              />
            </div>

            <div className="flex flex-col gap-2">
              <div className="flex items-center justify-between gap-3 bg-zinc-950 px-3 py-2 rounded-lg">
                <div className="flex flex-col gap-1 ">
                  <h1 className="text-base font-semibold">Data sources</h1>
                  <p className="text-sm">
                    Add data sources required in the workflow
                  </p>
                </div>
                <button
                  onClick={() => setIsDataSourceSelectionModalOpen(true)}
                  className="px-2 py-1 border border-zinc-200 duration-200 transition-all text-sm rounded-lg"
                >
                  ADD
                </button>
              </div>
              {
                <ul className="flex flex-wrap gap-2">
                  {currentTaskDataSourceFiles.length > 0 &&
                    currentTaskDataSourceFiles.map((file, idx) => (
                      <li
                        key={idx}
                        className="bg-zinc-100 text-zinc-800 px-3 py-1.5 rounded-full text-sm text-s-text"
                      >
                        <div className="flex items-center gap-2 max-w-[70%]">
                          {/* <FaFile className="text-white" /> */}
                          {getFileIcon(file.original_filename)}
                          <span
                            className="text-sm truncate cursor-pointer hover:whitespace-normal hover:overflow-visible hover:max-w-none transition-all"
                            title={`${file.original_filename}\nUploaded at: ${file.timestamp}`}
                          >
                            {file.original_filename}
                          </span>
                        </div>
                      </li>
                    ))}
                </ul>
              }
            </div>

            <div className="flex justify-end">
              <Button
                loading={isFormLoading}
                onClick={handleNewInstructionSubmission}
              >
                Continue
              </Button>
            </div>
            {/* --- MODAL DEFINITIONS --- */}
            {isTriggerNodeModalOpen && (
              <TriggerNodeModal
                mode={modalMode}
                nodeData={currentTriggerNodeData}
                onSave={handleSaveTrigger}
                onDelete={handleDeleteTrigger}
                onClose={() => {
                  setIsTriggerNodeModalOpen(false);
                  setCurrentTriggerNodeData(null);
                }}
                appEventData={appEventsData}
                isBot={true}
              />
            )}
            {botCreationId && (
              <TriggerModal
                title="Add trigger"
                desc="Give your assistant access to Oqlous actions."
                isOpen={isTriggerModalOpen}
                onClose={() => {
                  setIsTriggerModalOpen(false);
                  setEditOption(null);
                }}
                appsData={triggerOptions}
                selectedOptions={selectTrigerOptions}
                setSelectedOptions={setSelectTrigerOptions}
                editOption={editOption}
                botCreationId={botCreationId}
              />
            )}

            {botCreationId && (
              <TriggerModal
                title="Add integration"
                desc=" Select the app you’d like to add as integration."
                isOpen={isIntegrationModalOpen}
                onClose={() => {
                  setIsIntegrationModalOpen(false);
                  setEditOption(null);
                }}
                appsData={integrationData}
                selectedOptions={selectIntegrationOptions}
                setSelectedOptions={setSelectIntegrationOptions}
                editOption={editOption}
                botCreationId={botCreationId}
              />
            )}
            {isDataSourceSelectionModalOpen && (
              <DataSourceModal closeModal={handleDataSourceModalClose} />
            )}
          </div>
        </div>
      )}
      {showQuestionForm && !showTestScreen && (
        <div className="bg-zinc-900 h-[90%] max-w-3xl w-[90%] rounded-lg overflow-auto">
          <div className="flex justify-between gap-3 border-b border-zinc-800 px-3 py-5">
            <div className="px-3 py-1.5 bg-transparent text-xl font-bold flex items-center gap-3">
              <button
                onClick={() => setShowQuestionForm(false)}
                className="bg-2 transition-all duration-200 rounded-lg p-1.5"
              >
                <FaArrowLeftLong />
              </button>
              Clarification Questions
            </div>
            <div></div>
          </div>
          <div className="flex flex-col gap-8 p-6">
            <QuestionForm
              handleShowTestScreen={handleShowTestScreen}
              closeModal={closeModal}
              setShowQuestionForm={setShowQuestionForm}
              clearStates={clearStates}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default TriggerForm;